import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { IDialog } from '../../interfaces/common.interface';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent {
  config!: IDialog;
  private onCloseEvent: Subject<boolean> = new Subject(); // Observable to send data back
  onClose: Observable<boolean> = this.onCloseEvent.asObservable();

  constructor(private modalRef: BsModalRef) { }

  confirm(): void {
    this.onCloseEvent.next(true);
    this.modalRef?.hide();
    if (this.config?.confirmBtnClick) this.config.confirmBtnClick();
  }

  decline(): void {
    this.onCloseEvent.next(false);
    this.modalRef?.hide();
  }
}
